<main class="cashout-page">
  <div ds-progress-target [class.inprogress]="inProgress()">
    <header class="psp-header" aria-label="Paynet">
      <div class="psp-header-inner">
        <img
          class="merchant-logo"
          [src]="'/main/image?ptype=ecom_partners&pname=' + pageModel().logoCode"
          alt=""
        />
        <img
          class="paynet-logo"
          src="/content/images/ecom/new-logo-paynet.svg"
          alt="paynet"
        />
      </div>
    </header>

    <section class="main-block" aria-labelledby="h2_checkout">
      <h2
        ds-h2
        ds-variant="ecomcashout-title"
        class="text-truncate"
        id="h2_checkout"
      >
        {{ "ECOMCASHOUT.SETECOM.CHOOSEPAYMENTMETHOD" | translate }}
      </h2>

      <ul
        class="tabs"
        [attr.aria-label]="'ECOMCASHOUT.SETECOM.PAYMENTMETHOD' | translate"
      >
        <li class="tabs-title is-active">
          <button type="button" class="cashout-method" aria-pressed="true">
            <span class="cashout-method-image" aria-hidden="true"></span>
          </button>
        </li>
      </ul>

      <div class="tabs-content">
        <div>
          <h4
            ds-h4
            ds-variant="ecomcashout-caption"
            class="text-center text-truncate"
          >
            {{ "ECOMCASHOUT.SETECOM.AMOUNTTOPAY" | translate }}
          </h4>
        </div>

        <div>
          <h3 ds-h3 ds-variant="ecomcashout-amount" class="text-center">
            {{ pageModel().amountLabel }}
          </h3>
        </div>

        <details class="order-info" open>
          <summary class="order-info-btn">
            <span class="summary-info">
              <span>{{ "ECOMCASHOUT.SETECOM.OPERATION.TITLE" | translate }}</span>
            </span>
            <span class="exp-indicator">
              <span>{{ "ECOMCASHOUT.SETECOM.DETAILS" | translate }}</span>
            </span>
          </summary>

          <div class="order-info-content">
            <h2 ds-h2 ds-variant="ecomcashout-title">
              {{ "ECOMCASHOUT.SETECOM.OPERATION.TITLE" | translate }}
            </h2>

            <div class="detail-row">
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-label"
                class="text text-truncate"
                [title]="'ECOMCASHOUT.SETECOM.OPERATION.ID' | translate"
              >
                {{ "ECOMCASHOUT.SETECOM.OPERATION.ID" | translate }}
              </h5>
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-value"
                class="value text-right text-wrap"
              >
                {{ pageModel().operationId }}
              </h5>
            </div>
            <div class="detail-row">
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-label"
                class="text text-truncate"
                [title]="'ECOMCASHOUT.SETECOM.TRANSFERNUMBER' | translate"
              >
                {{ "ECOMCASHOUT.SETECOM.TRANSFERNUMBER" | translate }}
              </h5>
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-value"
                class="value text-right"
                [title]="pageModel().transferNumber"
              >
                {{ pageModel().transferNumber }}
              </h5>
            </div>
            <div class="detail-row">
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-label"
                class="text text-truncate"
                [title]="'ECOMCASHOUT.SETECOM.MERCHANT' | translate"
              >
                {{ "ECOMCASHOUT.SETECOM.MERCHANT" | translate }}
              </h5>
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-value"
                class="value text-right text-wrap"
                [title]="pageModel().merchantName"
              >
                {{ pageModel().merchantName }}
              </h5>
            </div>
            @if (pageModel().expirationDateLabel) {
            <div class="detail-row">
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-label"
                class="text text-truncate"
                [title]="'ECOMCASHOUT.SETECOM.OPERATION.EXPIRATIONDATE' | translate"
              >
                {{ "ECOMCASHOUT.SETECOM.OPERATION.EXPIRATIONDATE" | translate }}
              </h5>
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-value"
                class="value text-right text-nowrap"
                [title]="pageModel().expirationDateLabel"
              >
                {{ pageModel().expirationDateLabel | date }}
              </h5>
            </div>
            }
            @if (pageModel().operationStatus; as operationStatus) {
            <div class="detail-row">
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-label"
                class="text text-truncate"
                [title]="'ECOMCASHOUT.SETECOM.ORDER.STATUS' | translate"
              >
                {{ "ECOMCASHOUT.SETECOM.ORDER.STATUS" | translate }}
              </h5>
              <h5
                ds-h5
                ds-variant="ecomcashout-detail-value"
                class="value text-right text-wrap"
                [title]="statusLabelKey(operationStatus) | translate"
              >
                {{ statusLabelKey(operationStatus) | translate }}
              </h5>
            </div>
            }
            <div class="detail-row total">
              <h3
                ds-h3
                ds-variant="ecomcashout-section-title"
                class="text text-truncate"
              >
                {{ "ECOMCASHOUT.SETECOM.ORDER.TOTAL" | translate }}
              </h3>
              <h5
                ds-h5
                ds-variant="ecomcashout-total"
                class="value text-nowrap"
              >
                {{ pageModel().totalLabel }}
              </h5>
            </div>
          </div>
        </details>

        <div class="invoicing">
          <div class="invoicing-info">
            <div>
              <h3 ds-h3 ds-variant="ecomcashout-section-title">
                {{ "ECOMCASHOUT.SETECOM.STEPS.TITLE" | translate }}
              </h3>

              <h4 ds-h4 ds-variant="ecomcashout-step">
                {{ "ECOMCASHOUT.SETECOM.STEPS.SAVETRANSFERNUMBER" | translate }}
              </h4>
              <div class="invoice-number">
                <input
                  type="text"
                  [disabled]="true"
                  [value]="pageModel().transferNumber"
                  [attr.aria-label]="
                  'ECOMCASHOUT.SETECOM.TRANSFERNUMBER' | translate
                "
                />
                <button
                  type="button"
                  class="copy-button"
                  ds-button
                  [ds-variant]="
                    isTransferNumberCopied()
                      ? 'ecomcashout-copy-success'
                      : 'ecomcashout-copy'
                  "
                  (click)="copyTransferNumber()"
                  [attr.aria-label]="
                    (isTransferNumberCopied()
                      ? 'ECOMCASHOUT.SETECOM.COPIED'
                      : 'ECOMCASHOUT.SETECOM.SAVE'
                    ) | translate
                  "
                >
                  <span class="copy-icon" aria-hidden="true"></span>
                  <span aria-live="polite">
                    {{
                      (isTransferNumberCopied()
                        ? "ECOMCASHOUT.SETECOM.COPIED"
                        : "ECOMCASHOUT.SETECOM.SAVE"
                      ) | translate
                    }}
                  </span>
                </button>
              </div>

              <h4 ds-h4 ds-variant="ecomcashout-step">
                {{
                  (shouldShowResendEmail()
                    ? "ECOMCASHOUT.SETECOM.STEPS.SENDEMAIL"
                    : "ECOMCASHOUT.SETECOM.STEPS.CHECKEMAIL"
                  ) | translate
                }}
              </h4>
              <form (submit)="resendEmail($event)" novalidate>
                <div class="invoicing-email">
                  <input
                    type="email"
                    [formField]="emailForm.email"
                    [placeholder]="
                      'ECOMCASHOUT.SETECOM.EMAIL.PLACEHOLDER' | translate
                    "
                    [attr.aria-label]="
                      'ECOMCASHOUT.SETECOM.CUSTOMEREMAIL' | translate
                    "
                  />
                  <div ds-invalid-feedback>
                    {{ formvalidation.showError(emailForm.email) }}
                  </div>
                </div>
              </form>

              <h4 ds-h4 ds-variant="ecomcashout-step">
                {{ "ECOMCASHOUT.SETECOM.STEPS.RECEIVETRANSFER" | translate }}
                <a href="#map"
                  >{{ "ECOMCASHOUT.SETECOM.STEPS.MAPLINK" | translate }}</a
                >.
              </h4>
            </div>

            <div
              class="map"
              id="map"
              [attr.aria-label]="'ECOMCASHOUT.SETECOM.MAPPREVIEW' | translate"
            ></div>

            <div class="partners">
              <h3 ds-h3 ds-variant="ecomcashout-section-title">
                {{ "ECOMCASHOUT.SETECOM.PARTNERSTITLE" | translate }}
              </h3>
              <div class="partners-logo">
                <img src="/content/svg/psp/posta.svg" alt="Posta Moldovei" />
                <img src="/content/svg/psp/ecredit.svg" alt="E-Credit" />
                <img src="/content/svg/psp/petrom.svg" alt="Petrom" />
                <img
                  src="/content/svg/psp/microimprumut.svg"
                  alt="Microimprumut"
                />
              </div>
            </div>

            <div class="pay-button-group">
              @if (shouldShowResendEmail()) {
              <button
                type="button"
                class="button pay-button"
                [disabled]="!canResendEmail()"
                (click)="resendEmail($event)"
              >
                {{ "ECOMCASHOUT.SETECOM.SENDBYEMAIL" | translate }}
              </button>
              }
              <button
                type="button"
                class="button cancel-button"
                (click)="backToMerchant()"
              >
                {{ "ECOMCASHOUT.SETECOM.BACKTOMERCHANT" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer
        class="footer-logo"
        [attr.aria-label]="'ECOMCASHOUT.SETECOM.SECURITYSTANDARDS' | translate"
      >
        <img
          src="/content/images/logos/verifiedbyvisa.png"
          alt="verified-by-visa"
        />
        <img
          src="/content/images/logos/mastercardsecurecode.png"
          alt="mastercard-secure-code"
        />
        <img src="/content/images/logos/pcidss.png" alt="pci-dss" />
      </footer>
    </section>

    <footer class="psp-footer">
      <div class="footer-link">
        <a target="_blank" rel="noopener" href="/home/about">
          {{ "ECOMCASHOUT.SETECOM.FOOTER.ABOUT" | translate }}
        </a>
        <a target="_blank" rel="noopener" href="/blog">
          {{ "ECOMCASHOUT.SETECOM.FOOTER.BLOG" | translate }}
        </a>
        <a target="_blank" rel="noopener" href="/home/terms?isWeb=da">
          {{ "ECOMCASHOUT.SETECOM.FOOTER.TERMS" | translate }}
        </a>
        <a target="_blank" rel="noopener" href="/home/frequently?isWeb=da">
          {{ "ECOMCASHOUT.SETECOM.FOOTER.FAQ" | translate }}
        </a>
        <a target="_blank" rel="noopener" href="/home/contacts">
          {{ "ECOMCASHOUT.SETECOM.FOOTER.CONTACTS" | translate }}
        </a>
      </div>
    </footer>
  </div>
  <app-spinner [fullScreen]="true" [inProgress]="inProgress()" />
</main>
